import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadManual } from "../manual/loaders.ts";
import { ManualIndexPage } from "../manual/manual-page.tsx";
import { ManualPending } from "../manual/pending.tsx";
import { canBrowseManual } from "../manual/permissions.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !canBrowseManual(viewer) ? <NoAccessPage /> : <ManualIndexPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/manual/")({
  loader: async ({ context }) => loadManual(context.data),
  pendingComponent: ManualPending,
  component: Page,
});
